import { calculateDiscountValue, GetUSDCurrencyString } from "pages/3DSStore/PurchaseProduct/Components/FeeWaiver/FeeWaiverLogic";
import React from "react";
import MCSReadonlyField from 'components/MCSReadonlyField';

const SubscriptionFeeWaiverField = (props) => {

    return (
        <MCSReadonlyField
            label="Fee Waiver or Fee Discount Applied"
            text={
                <span style={{ color: "red" }}>
                    {`-${GetUSDCurrencyString(
                        calculateDiscountValue(props.amount, props.feeWaiverPercentage)
                    )}`}
                </span>
            }
        />
    );
};

export default SubscriptionFeeWaiverField;
